'use strict';

// TODO: CORE-456
export default {
	MINECRAFT: {
		id: 1,
		name: 'Minecraft',
		icon: 'icon-minecraft'
	},

	ROBLOX: {
		id: 2,
		name: 'Roblox',
		icon: 'icon-roblox-studio'
	}
};
